'use client';
import './_assets/styles/globals.css';
export { default } from '@corekit/core/src/app/global-error';
